<template>
	<div class="layout-inner dashbaord modern_dashboard">
		<navbar></navbar>
		<div class="layout-container">
			<div class="layout-content">
				<div v-if="!isDataLoaded" class="w-100 h-100 d-flex justify-content-center align-items-center">
          <spinner size="large"></spinner>
        </div>
				<div class="container-fluid flex-grow-1 pg_content_container" v-if="isDataLoaded" v-bind:style="{ backgroundImage: 'url(' + institution.dashboardBgImage+ ')'}" style="background-size: cover; background-position: center;">
					<div class="col-12" style="margin: auto; height: 100%;">

						<div class="row comp_row" v-if="courses.length>0">
							<div class="col-12 comp_col" v-if="courses.length>0">
								<learner-program-course-learn-v2 :program="programGuide" :courseStream="courses[0]"></learner-program-course-learn-v2>
							</div>
						</div>
						<div class="row comp_row" v-if="courses.length>1">
							<div class="col-12 comp_col" v-if="courses.length>1">
								<learner-program-course-learn-v2 :program="programGuide" :courseStream="courses[1]"></learner-program-course-learn-v2>
							</div>
						</div>
						<div class="row comp_row" v-if="courses.length>2">
							<div class="col-12 comp_col " v-if="courses.length>2">
								<learner-program-course-learn-v2 :program="programGuide" :courseStream="courses[2]"></learner-program-course-learn-v2>
							</div>
						</div>

						<div class="row comp_row" v-if="courses.length==0">
							<div class="comp_col col-12" v-if="isDataLoaded">
								<learner-explore-programs></learner-explore-programs>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>





<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
	import { PACKAGE } from '../../../package_constants'
	import LearnerProgramCourseLearnV2 from './LearnerProgramCourseLearnV2'
	import LearnerExplorePrograms from './LearnerExplorePrograms'
	import Navbar from '../../misc/components/./Navbar'
	import { getItem } from '../../../storage'

	export default {
		name: 'modern-dashboard',
		components: {
      LearnerProgramCourseLearnV2,
      LearnerExplorePrograms,
      Navbar
    },
		data: () => {
			return {
				programGuide: '',
        courses: [],
        careerGoalPragyaSoc: '',
				isDataLoaded: false,
				firstCourse:1,
				secondCourse:4,
				bgImage:'',
				modernDashboardComponents : [["LEARNINGV2","LEARNINGV2"],["LEARNINGV2", "LEARNINGV2"]]

			}
		},
		beforeMount () {
			this.populateDashboardData()
    },
    mounted () {
    	this.$root.$on('reloadLearnerDashboard', () => {
	      this.populateDashboardData()
	    })
    },
    watch: {
	    '$route' (to, from) {
	    		if(to.fullPath !==from.fullPath && to.fullPath.indexOf('/dashboard/modern')!=-1){
	    				this.populateDashboardData()
	    		}
	    }
	  },

    computed: {
    	...mapState({
    		'enabledFeatures': state => state.institution.enabledFeatures,
    		'institution': state => state.dashboard.institution,
    		'userObject': state => state.login.userObj,
	      'learnerDashboardComponents': state => state.dashboard.learnerDashboardComponents
	    }),
			userName () {
        return this.userObject.firstName
      },
      isExplorePackageEnabled () {
	      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
	      if (exploreFeature) {
	        return exploreFeature.enabled
	      }
	      return false
	    }
		},
		methods: {
			...mapActions([
				'loadLearnerDashboardState',
	      'loadLearnerEnrolledProgram',
	      'loadLearnerEnrolledProgramForCode',
	      'loadLearnerEnrollmentData',
	      'loadStreamWithStructure',
        'loadCareer'
	    ]),
	    async populateDashboardData () {
	    	let userObj = this.userObject
	    	await this.loadLearnerDashboardState()
	    	await this.loadLearnerEnrollmentData()
	    	let dashboardProgram = undefined
	    	await getItem('dashboardProgram').then(program => {
	    			dashboardProgram = program
	    	})
	    	// If dashboardProgram is different from Major1, take user to dashboardProgram
        if (userObj.major1) { 
          if(!dashboardProgram || dashboardProgram === 'undefined'|| userObj.major1 === dashboardProgram){
          		this.programGuide = await this.loadLearnerEnrolledProgram()
          }else{
          		this.programGuide = await this.loadLearnerEnrolledProgramForCode(dashboardProgram)
          }
		      let stream = await this.loadStreamWithStructure(this.programGuide.code)
	        let structure = stream.structure
	        if (structure) {
	          let children = JSON.parse(structure)
	          if (children.length > 0) {
	            let childStructure = children[0].structure
	            this.parentCategory = children[0]
	            if (childStructure) {
	              let structure = JSON.parse(childStructure)
	              this.courses = _.sortBy(structure, 'order')
	            }
	          }
	         }

          setTimeout(() => {
            this.isDataLoaded = true
          }, 0)
		    } else {
	      	this.isDataLoaded = true
	      }


	    }
	  }
	}
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/ModernDashboard.vue